import { Select, Spin } from 'antd';
import { debounce } from 'lodash';
import { useEffect, useState } from 'react';

const DADATA_TOKEN = '9b5e236999f907edff3b794a46d1c92e03bf30ef';

export const CitySelect = ({ value, onChange, placeholder = 'Выберите город' }) => {
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState('');

  const fetchCities = debounce(async (query) => {
    if (!query || query.length < 2) {
      setCities([]);
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(
        'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Token ${DADATA_TOKEN}`,
          },
          body: JSON.stringify({
            query: query,
            from_bound: { value: 'city' },
            to_bound: { value: 'city' },
          }),
        }
      );
      const data = await response.json();

      const uniqueCities = data.suggestions
        .map((item) => item.data.city)
        .filter((city, index, self) => city && self.indexOf(city) === index);

      setCities(uniqueCities);
    } catch (error) {
      console.error('Ошибка загрузки городов:', error);
    } finally {
      setLoading(false);
    }
  }, 400);

  useEffect(() => {
    if (searchValue) {
      fetchCities(searchValue);
    } else {
      setCities([]);
    }
  }, [searchValue]);

  return (
    <Select
      showSearch
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      onSearch={(val) => setSearchValue(val)}
      filterOption={false}
      notFoundContent={loading ? <Spin size="small" /> : 'Ничего не найдено'}
      options={cities.map((city) => ({ label: city, value: city }))}
      allowClear
    />
  );
};